module.exports = __webpack_public_path__ + "img/full-size.3bc368ae.svg";